import { render, staticRenderFns } from "./SystemAccessesRoleInfoModal.vue?vue&type=template&id=4f1231eb&scoped=true&"
import script from "./SystemAccessesRoleInfoModal.vue?vue&type=script&lang=ts&"
export * from "./SystemAccessesRoleInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./SystemAccessesRoleInfoModal.vue?vue&type=style&index=0&id=4f1231eb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1231eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
